import { initializeDateTimeFields } from "../../datetime";
export default function (cell, onRendered, success, cancel, editorParams) {
  const container = document.createElement("div");
  const input = document.createElement("input");
  input.setAttribute("class", "daterangeinput");

  const value = cell.getValue();
  if (value) {
    if (value.start && value.end)
      input.value = `${value.start} to ${value.end}`;
    else if (value.start) input.value = value.start;
    else if (typeof value === "string") input.value = value;
  }
  input.style.boxSizing = "border-box";
  input.style.width = "100%";
  function buildValues() {
    if (!input.value) {
      success("");
      return;
    }
    const values = input.value.split(" to ");
    if (values.length < 2) {
      success({ start: values[0] });
    } else if (values[0] === values[1]) {
      success({ start: values[0], end: values[0] });
    } else {
      success({ start: values[0], end: values[1] });
    }
  }
  input.addEventListener("change", buildValues);
  container.appendChild(input);
  initializeDateTimeFields(container, editorParams);
  onRendered(() => {
    const fp = input._flatpickr;
    if (!fp) return;
    // Create a per-instance copy — flatpickr shallow-copies defaultConfig so
    // config.onChange is a shared reference; mutating it would break all other instances.
    fp.config.onChange = [...fp.config.onChange, () => buildValues()];

    const weekBtn = document.createElement("button");
    weekBtn.type = "button";
    weekBtn.className = "flatpickr-clear-btn";
    weekBtn.textContent = gettext("Current week");
    weekBtn.addEventListener("click", () => {
      const now = new Date();
      const sunday = new Date(now);
      sunday.setDate(now.getDate() - now.getDay());
      const saturday = new Date(sunday);
      saturday.setDate(sunday.getDate() + 6);
      const fmt = (d) =>
        [
          d.getFullYear(),
          String(d.getMonth() + 1).padStart(2, "0"),
          String(d.getDate()).padStart(2, "0"),
        ].join("-");
      fp.setDate([sunday, saturday]);
      fp.close();
      input.value = `${fmt(sunday)} to ${fmt(saturday)}`;
      buildValues();
    });
    fp.calendarContainer.appendChild(weekBtn);

    const clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "flatpickr-clear-btn";
    clearBtn.textContent = gettext("Clear date");
    clearBtn.addEventListener("click", () => {
      fp.clear();
      fp.close();
      success("");
    });
    fp.calendarContainer.appendChild(clearBtn);
  });
  return container;
}
